// @flow

import { configureStore as reduxConfigureStore } from '@reduxjs/toolkit';
import config from './global/config';
import middlewares from './global/middlewares';
import reducer from './rootReducer';
import { translations } from './translations';
import {
  setDictionaries,
  setLanguages,
  setCurrentLanguage,
} from "./i18nReducer";


// Check for dev env, if false hide extensions like redux devtools
const { isDev } = config;


console.warn = function () { };
console.error = function () { };



const dictionaries = translations;

const languages = [
  {
    code: 'en-US',
    name: 'English (USA)'
  }
];

const configureStore = (initialState = {}, services = {}) => {
  const store = reduxConfigureStore({
    reducer,
    preloadedState: initialState,
    // Replaces applyMiddleware(...middlewares)
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middlewares),
    // Replaces the old devtools() enhancer: Redux DevTools only in dev
    devTools: isDev,
  });
  store.dispatch(setDictionaries(dictionaries));
  store.dispatch(setLanguages(languages));
  store.dispatch(setCurrentLanguage('en-US'));
  return store;
};

export default configureStore;
